// extracted by mini-css-extract-plugin
export var centered = "_f-6";
export var flexible = "_f-5";
export var footer = "_f-k";
export var footerBorder = "_f-l";
export var header = "_f-c";
export var headerBorder = "_f-d";
export var headerDefault = "_f-g";
export var headerMedium = "_f-h";
export var headerPadding = "_f-e";
export var iconAndTitle = "_f-f";
export var large = "_f-4";
export var largePadding = "_f-a";
export var medium = "_f-3";
export var mediumPadding = "_f-9";
export var modal = "_f-0";
export var modalContainer = "_f-b";
export var noPadding = "_f-7";
export var skinny = "_f-1";
export var small = "_f-2";
export var smallPadding = "_f-8";
export var subtitle = "_f-j";
export var title = "_f-i";